module.exports = global["config"] = require("-!./loadConfig.js");